module.exports = __webpack_public_path__ + "static/media/yoav.bc6568d5.png";